import { call } from '@packages/functions';
import React, { Fragment } from 'react';

const ROUTERS = [
    require('./Auth/Router'),

    // Dashboard/* routes
    require('./Dashboard/Router'),

    // Wallet/* routes
    require('./Wallet/Router'),

    // Designs/* routes
    require('./Designs/Router'),

    // Builder/* routes
    require('./Builder/Router'),

    // Orders/* routes
    require('./Orders/Router'),

    // Cart system routes
    require('./Products/Router'),
    require('./MyCart/Router'),
    // ContactTab Router
    require('./Contact/Router'),

    // Notifications Routes
    require('./Notifications/Router'),
    //

    // Notifications Routes
    require('./Help/Router'),
    // Redo Request Routes
    require('./Apparel/RedoRequests/Router'),

    // Promo Codes Routes
    require('./PromoCodes/Router'),

    // Wholesaler Routes
    require('./Apparel/Wholesalers/Router'),

    // Wholesaler Account Routes
    require('./Apparel/WholesalerAccount/Router'),
    // Reports Routes
    require('./Apparel/Reports/Router'),

    // Older Routers
    require('./Apparel/Account/Router'),
    require('./Apparel/Customers/Router'),
    require('./Apparel/Designs/Router'),

    require('./Apparel/InstantQuote/Router'),
    require('./Apparel/Orders/Router'),
    require('./Apparel/Sales/Router'),
    require('./Apparel/Designers/Router'),
    require('./Apparel/Skus/Router'),
    require('./Apparel/Packages/Router'),
    require('./Apparel/Categories/Router'),
    require('./Apparel/Finances/Router'),
    require('./Apparel/Questionnaire/Router'),
    require('./Apparel/AddOns/Router'),
    require('./Apparel/SalesTax/Router'),
    require('./Apparel/Factories/Router'),
    require('./Apparel/ShippingMethods/Router'),
];

const renderRouters = (routers) => {
    let routers$ = routers
        .map((router) => call(router.default || router.router || router))
        .filter((router) => !!router);

    routers$ = routers$.reduce((routers, router) => {
        let collection = [];

        if (router.type === Fragment) {
            collection = router.props.children ? (React.Children.toArray(router.props.children) as any) : [];
        }

        return [...routers, ...collection];
    }, []);

    return routers$;
};

export const routesCollection = renderRouters(ROUTERS);
